const BankAccountsSkeleton = () => {
  return (
    <div className="space-y-3">
      {Array(4)
        .fill(0)
        .map((_, index) => (
          <div
            key={index}
            className="relative overflow-hidden rounded-2xl border border-gray-100 bg-white p-3 dark:border-gray-700/60 dark:bg-gray-800 md:p-4"
          >
            {/* Shimmer overlay */}
            <span
              aria-hidden
              className="pointer-events-none absolute inset-0 -translate-x-full animate-[bankShimmer_1.6s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent dark:via-white/5"
            />

            <div className="relative flex items-center justify-between gap-3">
              <div className="flex items-center gap-3">
                <div className="h-4 w-4 rounded bg-gray-100 dark:bg-gray-700" />
                <div className="h-12 w-12 rounded-2xl bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-700 dark:to-gray-800" />
                <div className="space-y-1.5">
                  <div className="h-4 w-32 rounded-full bg-gradient-to-r from-gray-200 to-gray-100 dark:from-gray-700 dark:to-gray-800 sm:w-48" />
                  <div className="h-3 w-20 rounded-full bg-gray-100 dark:bg-gray-800 sm:w-28" />
                </div>
              </div>

              <div className="flex items-center gap-2">
                <div className="h-6 w-14 rounded-full bg-gradient-to-r from-emerald-100/60 to-gray-100 dark:from-emerald-950/40 dark:to-gray-800" />
                <div className="h-9 w-9 rounded-lg bg-gray-100 dark:bg-gray-700" />
              </div>
            </div>
          </div>
        ))}

      <style>{`@keyframes bankShimmer { 100% { transform: translateX(100%); } }`}</style>
    </div>
  );
};

export default BankAccountsSkeleton;
